export default __webpack_public_path__ + "static/media/yubi-normal.154689a3.svg";